export default {

  configItems: (state) => {
    return state.configItems;
  },

  pageContent: (state) => {
    return state.pageContent;
  },

  banners: (state) => {
    return state.banners;
  },

  bankCards: (state) => {
    return state.bankCards;
  },
  bankCard: (state) => {
    return state.bankCard;
  },
  bankCardOptions: (state) => {
    const options = [];
    state.bankCards.forEach((item) => {
      const pushItem = {
        value: item.id,
        number: item.cardNumber,
        text: item.bank.title + ' | ' + item.cardNumber,
      };
      options.push(pushItem);
    });
    return options;
  },

  tickets: (state) => {
    return state.tickets;
  },
  ticket: (state) => {
    return state.ticket;
  },

  dashboardItems: (state) => {
    return state.dashboardItems;
  },

  searchVendors: (state) => {
    return state.searchVendors;
  },

  requirementProfile: (state) => {
    return state.requirementProfile;
  },


};
